module.exports = __webpack_public_path__ + "img/slack.1ce9d252.svg";